import { SET_GYM, SET_GYMS, SET_GYM_ATTRIBUTES} from '../../actions/types/types';

const initState = {
  gyms: [],
  count:0,
  gym: {}, // shuold be true later on but for now keep it false
  gymAttributes:[]
};

const GymReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_GYMS:
      return {
        ...state,
        gyms: action.payload.data,
        count: action.payload.count
      };
    case SET_GYM:
      return { ...state, gym: action.payload.data };
    case SET_GYM_ATTRIBUTES:
    return { ...state, gymAttributes: action.payload.data };
    default:
      return { ...state };
  }
};

export default GymReducer;
